"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveTrackingTransport = exports.TrackingConfigTransport = exports.AdminConfigureTrackingInput = exports.TrackingIntervalLabels = exports.TrackingInterval = exports.TrackingIntervals = exports.TrackingCreateInput = exports.TrackingTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
exports.TrackingTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    profileID: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    shiftID: typebox_1.Type.String({ format: 'uuid' }),
    latitude: typebox_1.Type.Number(),
    longitude: typebox_1.Type.Number(),
    locationClass: typebox_1.Type.String(),
    locationReferenceID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    metadata: common_1.MetaData,
});
exports.TrackingCreateInput = typebox_1.Type.Object({
    sentAt: typebox_1.Type.String({
        format: 'date-time',
        description: 'The time the tracking point was sent. Used to determine latency.',
    }),
    latitude: typebox_1.Type.Number(),
    longitude: typebox_1.Type.Number(),
});
/**
 * The tracking interval is the time in seconds between tracking points.
 * If the tracking interval is 0, then all tracking points will be saved.
 */
exports.TrackingIntervals = [0, 15, 30, 60];
exports.TrackingInterval = typebox_1.Type.Union(exports.TrackingIntervals.map((interval) => typebox_1.Type.Literal(interval)));
exports.TrackingIntervalLabels = {
    0: 'No delay',
    15: '15 seconds',
    30: '30 seconds',
    60: '60 seconds',
};
exports.AdminConfigureTrackingInput = typebox_1.Type.Object({
    enableLocationTracking: typebox_1.Type.Boolean(),
    enableTimeClock: typebox_1.Type.Boolean(),
    trackingInterval: exports.TrackingInterval,
});
exports.TrackingConfigTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid', description: 'This is just the haulerID' }),
    enableLocationTracking: typebox_1.Type.Boolean(),
    enableTimeClock: typebox_1.Type.Boolean(),
    trackingInterval: exports.TrackingInterval,
});
exports.LiveTrackingTransport = typebox_1.Type.Object({
    asOf: typebox_1.Type.String({ format: 'date-time' }),
    results: typebox_1.Type.Array(typebox_1.Type.Object({
        profileID: typebox_1.Type.String({ format: 'uuid' }),
        tracking: typebox_1.Type.Array(exports.TrackingTransport),
        lastTrackingPoint: typebox_1.Type.Optional(exports.TrackingTransport),
        approxDistance: typebox_1.Type.Optional(typebox_1.Type.Object({ distance: typebox_1.Type.Number(), unit: typebox_1.Type.Literal('MILES') })),
        geoJSON: typebox_1.Type.String() /* I'd like a better solution than this */,
        // and now days later I cannot remember why I did this so I'm going to leave it :D (I think it was for the map)
    })),
});
//# sourceMappingURL=tracking-transport.js.map